import React, { Suspense } from 'react'
import { Helmet } from 'react-helmet'
import LoginLogo from '../../Assets/Icons/LoginLogo'
import Loader from '../Loader/Loader'
import useWindowSize from '../../hooks/useWindowSize'
import { useStyles } from './LoginStyles'

const LoginButton = React.lazy(() => import('./loginButton'))

export default function SignInSide({ setReload }) {
  const { width, height } = useWindowSize()
  const zoomOut = (height < 550 && width > 600) || height < 320
  const aboveTabScreenSize = width > 600 && height > 500
  const classes = useStyles({ zoomOut, aboveTabScreenSize })

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>
      <div className={classes.loginPageContainer}>
        <div className={classes.loginPageContent} style={{ maxWidth: '960px' }}>
          <div className={classes.loginPageTextContent}>
            <span className={classes.signInTitle}>Sign In</span>
            <p className={classes.signInContent}>
              Create and conduct quizzes in no time to hire the best tech talent
              remotely.
            </p>
            <Suspense
              fallback={
                <div className={classes.centerLoader}>
                  <Loader size={30} />
                </div>
              }
            >
              <LoginButton setReload={setReload} />
            </Suspense>
          </div>
          <div className={classes.loginLogoContainer}>
            <LoginLogo />
          </div>
        </div>
      </div>
    </>
  )
}
